import { Pipe, PipeTransform } from '@angular/core';
import { AccountStatus } from '@app/shared/models/account-status';

@Pipe({ name: 'userAccountStatus' })
export class UserAccountStatusPipe implements PipeTransform {
	transform (status: AccountStatus): string {
		switch (status) {
			case AccountStatus.Active:
				return $localize`:@@common.active:Active`;
			case AccountStatus.OnBoarding:
				return $localize`:@@common.on-boarding:On-Boarding`;
			case AccountStatus.New:
				return $localize`:@@common.new:New`;
			case AccountStatus.Disabled:
				return $localize`:@@common.disabled:Disabled`;
			default:
				return $localize`:@@common.na:N/A`;
		}
	}
}